
import { supabase } from '../../integrations/supabase/client';
import { UserUpdateInput } from './types';

/**
 * Updates user information
 * @param userId - The user ID to update
 * @param updates - The user data updates
 */
export const updateUser = async (userId: string, updates: UserUpdateInput) => {
  return await supabase
    .from('users')
    .update(updates)
    .eq('id', userId)
    .select();
};

/**
 * Updates a user's email address
 * @param email - The new email address
 */
export const updateUserEmail = async (email: string) => {
  return await supabase.auth.updateUser({
    email: email,
  });
};

/**
 * Gets user information by ID
 * @param userId - The user ID to query
 */
export const getUserById = async (userId: string) => {
  return await supabase
    .from('users')
    .select('*')
    .eq('id', userId)
    .single();
};
